import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "overflow-x-auto" }
const _hoisted_2 = { class: "w-full border border-ternary text-base font-normal leading-[21px] text-left text-brown sectors-table" }
const _hoisted_3 = { class: "font-semibold" }
const _hoisted_4 = { class: "text-center align-middle border px-3 py-2" }
const _hoisted_5 = { class: "border px-3 py-2" }
const _hoisted_6 = { class: "border px-3 py-2" }
const _hoisted_7 = { class: "border px-3 py-2" }
const _hoisted_8 = { class: "border px-3 py-2" }
const _hoisted_9 = {
  key: 0,
  class: "text-center align-middle border px-3 py-2",
  rowspan: "3"
}
const _hoisted_10 = { class: "border px-3 py-2" }
const _hoisted_11 = { class: "border px-3 py-2" }
const _hoisted_12 = { class: "border px-3 py-2" }
const _hoisted_13 = { class: "border px-3 py-2" }

import AccordionComponent from "@/components/accordion/AccordionComponent.vue";
import { useI18n } from "vue-i18n";
import { sectors } from "@/constants/activationSectors";


export default /*@__PURE__*/_defineComponent({
  __name: 'SectorsAccordionFAQ',
  setup(__props) {

const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AccordionComponent, null, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)("faq.sectors.title")), 1)
    ]),
    "faq-content": _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("table", _hoisted_2, [
          _createElementVNode("thead", _hoisted_3, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", _hoisted_4, _toDisplayString(_unref(t)("faq.sectors.headers.direction")), 1),
              _createElementVNode("th", _hoisted_5, _toDisplayString(_unref(t)("faq.sectors.headers.compas-direction")), 1),
              _createElementVNode("th", _hoisted_6, _toDisplayString(_unref(t)("faq.sectors.headers.mountain")), 1),
              _createElementVNode("th", _hoisted_7, _toDisplayString(_unref(t)("faq.sectors.headers.name")), 1),
              _createElementVNode("th", _hoisted_8, _toDisplayString(_unref(t)("faq.sectors.headers.hieroglyph")), 1)
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sectors), (sector, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                (sector.direction !== undefined)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_9, _toDisplayString(_unref(t)(sector.direction)), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("td", _hoisted_10, _toDisplayString(sector.degree), 1),
                _createElementVNode("td", _hoisted_11, _toDisplayString(_unref(t)(sector.mountain)), 1),
                _createElementVNode("td", _hoisted_12, _toDisplayString(_unref(t)(sector.name)), 1),
                _createElementVNode("td", _hoisted_13, _toDisplayString(sector.hieroglyph), 1)
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    "collapse-text-btn": _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)("faq.sectors.collapse_btn")), 1)
    ]),
    _: 1
  }))
}
}

})